document.addEventListener('DOMContentLoaded', function () {
  var sections = document.querySelectorAll('.features-grid');

  sections.forEach(function (section) {
    var dots = section.querySelectorAll('.features-grid__dot');
    var cards = section.querySelectorAll('.feature-card');
    var details = section.querySelectorAll('.features-grid__detail-item');
    var detailPanel = section.querySelector('.features-grid__detail');

    function setActive(id) {
      dots.forEach(function (d) {
        d.classList.toggle('is-active', d.dataset.feature === id);
      });
      cards.forEach(function (c) {
        c.classList.toggle('is-active', c.dataset.feature === id);
      });
      details.forEach(function (d) {
        d.classList.toggle('is-active', d.dataset.feature === id);
      });
      if (detailPanel) {
        detailPanel.classList.toggle('is-visible', id !== null);
      }
    }

    function handleSelect(id, source) {
      var alreadyActive = source.classList.contains('is-active');
      setActive(alreadyActive ? null : id);
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        handleSelect(dot.dataset.feature, dot);
      });
    });

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        handleSelect(card.dataset.feature, card);
      });
    });
  });
});
